/**
 * 2-blok — asosiy xizmatlarga tezkor o'tish: ihcham, ikonkali qator.
 * Har bir tugma tegishli modulning alohida sahifasini ochadi; hali ishga
 * tushmaganlari «Tez kunda» belgisi bilan ko'rsatiladi (`MODULE_STATUS`).
 */
import { Link } from "react-router-dom";

import { QUICK_SERVICES } from "@/shared/data/publicNav";
import { useI18n } from "@/shared/i18n";
import { Icon } from "@/shared/ui/Icon";

import { stagger } from "./helpers";

export function QuickServices() {
  const { t } = useI18n();
  return (
    <section className="quick" aria-labelledby="quick-title">
      <div className="container">
        <h2 id="quick-title" className="visually-hidden">
          {t("quick.title")}
        </h2>
        <ul className="quick-grid">
          {QUICK_SERVICES.map((item, index) => {
            const soon = item.status === "soon";
            return (
              <li key={item.key} data-reveal style={stagger(index)}>
                <Link className={`quick-tile${soon ? " is-soon" : ""}`} to={item.to}>
                  <span className="quick-icon">
                    <Icon name={item.icon} size={24} />
                  </span>
                  <span className="quick-copy">
                    <b>
                      {t(item.label)}
                      {soon ? <span className="soon-badge">{t("nav.soon")}</span> : null}
                    </b>
                    <small>{t(item.text)}</small>
                  </span>
                  {soon ? null : <Icon name="arrowRight" size={18} className="quick-go" />}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
